export const EventType = {
    Landing: 'ShoppingMissionEntryPageLanding' as const,
    ClipboardClick: 'ClipboardClick' as const,
    MissionClick: 'MissionClick' as const,
    ShoppingAnswerSubmitClick: 'ShoppingAnswerSubmitClick' as const,
    ShoppingParticipationMethodClick: 'ShoppingParticipationMethodClick' as const,
    ShoppingParticipationSuccessPageLanding: 'ShoppingParticipationSuccessPageLanding' as const,
    ShoppingExhaustedPageLanding: 'ShoppingExhaustedPageLanding' as const,
    ShoppingTodayParticipationLimitPageLanding: 'ShoppingTodayParticipationLimitPageLanding' as const,
    ShoppingRewardFailurePageLanding: 'ShoppingRewardFailurePageLanding' as const,
    ShoppingServerErrorPageLanding: 'ShoppingServerErrorPageLanding' as const,
    ShoppingAnotherMissionClick: 'ShoppingAnotherMissionClick' as const,
} as const;

export type EventType = typeof EventType[keyof typeof EventType];

export const PlaceEventType = {
    PlaceMissionEntryPageLanding: 'PlaceMissionEntryPageLanding' as const,
    PlaceClipboardClick: 'PlaceClipboardClick' as const,
    PlaceMissionClick: 'PlaceMissionClick' as const,
    PlaceAnswerSubmitClick: 'PlaceAnswerSubmitClick' as const,
    PlaceParticipationMethodClick: 'PlaceParticipationMethodClick' as const,
    PlaceParticipationSuccessPageLanding: 'PlaceParticipationSuccessPageLanding' as const,
    PlaceExhaustedPageLanding: 'PlaceExhaustedPageLanding' as const,
    PlaceTodayParticipationLimitPageLanding: 'PlaceTodayParticipationLimitPageLanding' as const,
    PlaceRewardFailurePageLanding: 'PlaceRewardFailurePageLanding' as const,
    PlaceServiceErrorPageLanding: 'PlaceServiceErrorPageLanding' as const,
    PlaceAnotherMissionClick: 'PlaceAnotherMissionClick' as const
} as const;

export type PlaceEventType = typeof PlaceEventType[keyof typeof PlaceEventType];